export const constants = {
    SAVE_SHARED_ROOM_IN_PROGRESS : "SAVE_SHARED_ROOM_IN_PROGRESS",
    SAVE_SHARED_ROOM_COMPLETE : "SAVE_SHARED_ROOM_COMPLETE"
}